"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      flexGrow: 1
    },
    tabsRoot: {
      borderBottom: "1px solid ".concat(theme.palette.secondary.tabBorder)
    },
    tabsIndicator: {
      backgroundColor: theme.palette.primary.dark,
      '&.disabled': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    tabRoot: function tabRoot(props) {
      return {
        textTransform: 'initial',
        padding: props.fullWidth ? [[0, 0]] : [[6, 12]],
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        color: theme.palette.secondary.main,
        '&:hover': {
          color: theme.palette.primary.dark,
          opacity: 1
        },
        '&:focus': {
          color: theme.palette.primary.dark
        }
      };
    },
    tabSelected: {
      // for some reason, root takes precedence over selected
      '&&': {
        color: theme.palette.primary.dark
      }
    }
  };
};

exports.default = _default;